import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./slices/uiSlice";
import savedProgressReducer from "./slices/savedProgressSlice";
import searchReducer from "./slices/searchSlice";
import appReducer from "./slices/appSlice";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    savedProgress: savedProgressReducer,
    search: searchReducer,
    app: appReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
